import { createDecorator } from 'vue-class-component';

const noop = () => {};

export const Destroyed = createDecorator((options, key) => {
    if (options && options.methods) {
        const original = options.destroyed || noop;
        const method = options.methods[key] || noop;

        options.destroyed = function() {
            original.call(this);
            method.call(this);
        };
    }
});

export const Mounted = createDecorator((options, key) => {
    if (options && options.methods) {
        const original = options.mounted || noop;
        const method = options.methods[key] || noop;

        options.mounted = function() {
            original.call(this);
            method.call(this);
        };
    }
});

export const Created = createDecorator((options, key) => {
    if (options && options.methods) {
        const original = options.created || noop;
        const method = options.methods[key] || noop;

        options.created = function() {
            original.call(this);
            method.call(this);
        };
    }
});
